module.exports = __webpack_public_path__ + "static/media/cloudera_logo.81a3bd14.png";